// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.small-tag {
  font-size: 12px !important; /* forcefully override */
}

.small-button {
  font-size: 10px !important; /* smaller text */
  padding: 2px 5px !important; /* shrink padding */
  height: 30px !important; /* optional: control height */
  min-width: auto !important; /* optional: remove min width */
}

.simulation-section {
  height: 92vh;
  position: relative;
}
.simulation-section .Vessel-Out .MultiSelect__multi-value:first-child .MultiSelect__multi-value__remove {
  pointer-events: none !important;
  opacity: 0;
}
.simulation-section .close-icon {
  display: flex;
  border-radius: 2px;
  padding-left: 4px;
  padding-right: 4px;
  box-sizing: border-box;
}
.simulation-section .dtco-performa-option-active {
  background-color: var(--performa-option-active);
}
.simulation-section .dtco-performa-option-active:hover {
  background-color: var(--performa-option-hover);
}
.simulation-section .dtco-performa-option-disabled {
  background-color: var(--performa-option-disabled);
  color: var(--performa-option-disabled-color) !important;
  cursor: not-allowed;
  pointer-events: all !important;
}
.simulation-section .DuplicateModal .ServiceList {
  margin-top: 15px;
}
.simulation-section .RefreshBtn {
  position: absolute;
  right: 0px;
  top: 0px;
}
.simulation-section .DuplicateModal .MultiSelect__value-container {
  max-height: 150px;
  overflow-x: hidden !important;
  overflow-y: auto;
}
.simulation-section .filter-div .MultiSelect__value-container {
  height: 35px;
  overflow-x: hidden !important;
  overflow-y: auto;
}
.simulation-section .filter-div .MultiSelect__placeholder {
  text-transform: none;
}
.simulation-section .filter-div .input-label {
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 2px;
}
.simulation-section .filter-div .wrapper-inputDate > div .inputDate {
  min-height: 37px;
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid rgb(207, 207, 207);
}
.simulation-section .simulation-generation {
  padding: 10px 10px 15px;
  border: solid 1px var(--border-color);
  margin-bottom: 20px;
  background: var(--color-white);
}
.simulation-section .simulation-generation button {
  margin-top: 28px;
}
.simulation-section .simulation-generation .MultiSelect__value-container {
  height: 36px;
  overflow-x: hidden !important;
  overflow-y: auto;
}
.simulation-section .simulation-generation .MultiSelect__indicators button {
  margin-top: 0px;
}
.simulation-section .simulation-generation .MultiSelect__multi-value__label {
  font-size: var(--font-size-sm);
}
.simulation-section .data-section {
  background: var(--color-white);
  border: solid 1px var(--border-color);
  padding: 10px;
}
.simulation-section .data-section .result-header {
  position: relative;
  margin-bottom: 2rem;
}
.simulation-section .data-section .result-header .search {
  position: absolute;
  right: 0;
  top: 5px;
}
.simulation-section .data-section .simulationList {
  border: solid 1px var(--border-color);
  background: var(--color-white);
  display: flex;
  margin-top: 30px;
  border-radius: 0px;
  position: relative;
}
.simulation-section .data-section .simulationList .opt-type-display {
  position: absolute;
  top: -18px;
  font-size: 10px;
  color: white;
  background-color: var(--color-maersk-blue);
  padding: 1px 5px;
  left: 0px;
  border-radius: 3px 3px 0px 0px;
}
.simulation-section .data-section .simulationList .icon-section {
  padding: 5px;
  margin: 0px 10px;
}
.simulation-section .data-section .simulationList .value-section {
  width: 100%;
}
.simulation-section .data-section .simulationList .value-section .mainheader {
  font-weight: 500;
  line-height: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.simulation-section .data-section .simulationList .value-section .mainheader .vesel-status {
  background: var(--color-lightGreen);
  padding: 2px 6px;
  border-radius: 3px;
  color: #007800;
  font-size: var(--font-size-sm);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
  display: inline-block;
  margin-left: 5px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle {
  font-size: 14px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section {
  margin-bottom: 15px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .header {
  color: var(--color-font);
  font-weight: 700;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .time-details {
  color: var(--color-font);
  font-size: var(--font-size-xs);
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .content {
  font-size: 14px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .content .showmore {
  color: #0073ab;
  text-decoration: underline;
  margin-left: 5px;
  font-size: var(--font-size-sm);
  cursor: pointer;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .tags {
  border-radius: 20px;
  padding: 1px 5px;
  line-height: 16px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .tags span {
  font-size: var(--font-size-sm);
  white-space: nowrap;
  font-weight: normal;
  color: #00243d;
  border-radius: 3px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .icon-section {
  display: flex;
  align-items: center;
  justify-content: center;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .icon-section .icon-list {
  margin-right: 5px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .tooltip-text {
  visibility: hidden;
  position: absolute;
  z-index: 1;
  width: 200px;
  color: var(--color-black);
  font-size: 12px;
  background-color: var(--color-white);
  border-radius: 10px;
  padding: 10px 15px 10px 15px;
  border: solid 1px var(--border-color);
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .hover-text:hover .tooltip-text {
  visibility: visible;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section #top {
  top: -50px;
  left: -6rem;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .hover-text {
  position: relative;
  display: inline-block;
  text-align: center;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .header {
  color: #545454;
  font-size: var(--font-size-sm);
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section {
  height: 38px;
  display: flex;
  text-align: center;
  margin-top: 5px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress {
  width: 100px;
  margin-left: 5px;
  border: solid 1px var(--color-maersk-darkblue);
  align-items: center;
  display: flex;
  justify-content: center;
  background: var(--color-white);
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress.error {
  background-color: var(--color-lightRed);
  color: #970000;
  border: solid 1px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress.success {
  background-color: var(--color-lightGreen);
  color: #009700;
  border: solid 1px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress.active {
  display: block;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress.active .step {
  background-color: var(--color-maersk-darkblue);
  color: var(--color-white);
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress .time {
  font-size: var(--font-size-xs);
  background-color: var(--color-maersk-blue);
  color: var(--color-white);
}
.simulation-section .data-section .simulationList .value-section .pull-right {
  float: right;
}
.simulation-section .data-section .simulationList .value-section .button {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/SimulationRequest/SimulationRequest.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA,EAAA,wBAAA;AACF;;AACA;EACE,0BAAA,EAAA,iBAAA;EACA,2BAAA,EAAA,mBAAA;EACA,uBAAA,EAAA,6BAAA;EACA,0BAAA,EAAA,+BAAA;AAEF;;AAAA;EACE,YAAA;EACA,kBAAA;AAGF;AADI;EACE,+BAAA;EACA,UAAA;AAGN;AAAE;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAEJ;AAAE;EACE,+CAAA;AAEJ;AACE;EACE,8CAAA;AACJ;AAEE;EACE,iDAAA;EACA,uDAAA;EACA,mBAAA;EACA,8BAAA;AAAJ;AAGI;EACE,gBAAA;AADN;AAIE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAFJ;AAKI;EACE,iBAAA;EACA,6BAAA;EACA,gBAAA;AAHN;AAOI;EACI,YAAA;EACA,6BAAA;EACA,gBAAA;AALR;AAQI;EACI,oBAAA;AANR;AAQI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AANN;AAQI;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,oCAAA;AANN;AASE;EACE,uBAAA;EACA,qCAAA;EACA,mBAAA;EACA,8BAAA;AAPJ;AAQI;EACE,gBAAA;AANN;AAQI;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AANN;AASM;EACE,eAAA;AAPR;AAUI;EACE,8BAAA;AARN;AAWE;EACE,8BAAA;EACA,qCAAA;EACA,aAAA;AATJ;AAUI;EACE,kBAAA;EACA,mBAAA;AARN;AASM;EACE,kBAAA;EACA,QAAA;EACA,QAAA;AAPR;AAUI;EACE,qCAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AARN;AASM;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,0CAAA;EACA,gBAAA;EACA,SAAA;EACA,8BAAA;AAPR;AASM;EACE,YAAA;EACA,gBAAA;AAPR;AASM;EACE,WAAA;AAPR;AASQ;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAPV;AAQU;EACE,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AANZ;AASQ;EACE,eAAA;AAPV;AAQU;EACE,mBAAA;AANZ;AAOY;EACE,wBAAA;EACA,gBAAA;AALd;AAOY;EACE,wBAAA;EACA,8BAAA;AALd;AAOY;EACE,eAAA;AALd;AAMc;EACE,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;AAJhB;AAOY;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AALd;AAMc;EACE,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAJhB;AAOY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AALd;AAMc;EACE,iBAAA;AAJhB;AAOY;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,4BAAA;EACA,qCAAA;AALd;AAQY;EACE,mBAAA;AANd;AASY;EACE,UAAA;EACA,WAAA;AAPd;AASY;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;AAPd;AAUU;EACE,cAAA;EACA,8BAAA;AARZ;AAWU;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AATZ;AAUY;EACE,YAAA;EACA,gBAAA;EACA,8CAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AARd;AASc;EACE,uCAAA;EACA,cAAA;EACA,iBAAA;AAPhB;AASc;EACE,yCAAA;EACA,cAAA;EACA,iBAAA;AAPhB;AASc;EACE,cAAA;AAPhB;AAQgB;EACE,8CAAA;EACA,yBAAA;AANlB;AAWc;EACE,8BAAA;EACA,0CAAA;EACA,yBAAA;AAThB;AAcQ;EACE,YAAA;AAZV;AAcQ;EACE,eAAA;AAZV","sourcesContent":[".small-tag {\n  font-size: 12px !important;  /* forcefully override */\n}\n.small-button {\n  font-size: 10px !important; /* smaller text */\n  padding: 2px 5px !important; /* shrink padding */\n  height: 30px !important;     /* optional: control height */\n  min-width: auto !important;  /* optional: remove min width */\n}\n.simulation-section {\n  height: 92vh;\n  position: relative;\n  .Vessel-Out{\n    .MultiSelect__multi-value:first-child .MultiSelect__multi-value__remove {\n      pointer-events: none !important;\n      opacity: 0;\n  }\n  }\n  .close-icon{\n    display: flex;\n    border-radius: 2px;\n    padding-left: 4px;\n    padding-right: 4px;\n    box-sizing: border-box;\n  }\n  .dtco-performa-option-active {\n    background-color: var(--performa-option-active);\n  }\n\n  .dtco-performa-option-active:hover {\n    background-color: var(--performa-option-hover);\n  }\n\n  .dtco-performa-option-disabled {\n    background-color: var(--performa-option-disabled);\n    color: var(--performa-option-disabled-color) !important;\n    cursor: not-allowed;\n    pointer-events: all !important;\n  }\n  .DuplicateModal{\n    .ServiceList{\n      margin-top: 15px;\n    }\n  }\n  .RefreshBtn {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n  }\n  .DuplicateModal{\n    .MultiSelect__value-container {\n      max-height: 150px;\n      overflow-x: hidden !important;\n      overflow-y: auto;\n  }\n  }\n  .filter-div{\n    .MultiSelect__value-container {\n        height: 35px;\n        overflow-x: hidden !important;\n        overflow-y: auto;\n    }\n    \n    .MultiSelect__placeholder {\n        text-transform: none;\n    }\n    .input-label{\n      font-size: 14px;\n      line-height: 20px;\n      margin-bottom: 2px;\n    }\n    .wrapper-inputDate > div .inputDate{\n      min-height: 37px;\n      font-size: 14px;\n      border-radius: 3px;\n      border: 1px solid rgb(207, 207, 207);\n    }\n  }\n  .simulation-generation {\n    padding: 10px 10px 15px;\n    border: solid 1px var(--border-color);\n    margin-bottom: 20px;\n    background: var(--color-white);\n    button {\n      margin-top: 28px;\n    }\n    .MultiSelect__value-container {\n      height: 36px;\n      overflow-x: hidden !important;\n      overflow-y: auto;\n    }\n    .MultiSelect__indicators {\n      button {\n        margin-top: 0px;\n      }\n    }\n    .MultiSelect__multi-value__label {\n      font-size: var(--font-size-sm);\n    }\n  }\n  .data-section {\n    background: var(--color-white);\n    border: solid 1px var(--border-color);\n    padding: 10px;\n    .result-header {\n      position: relative;\n      margin-bottom: 2rem;\n      .search {\n        position: absolute;\n        right: 0;\n        top: 5px;\n      }\n    }\n    .simulationList {\n      border: solid 1px var(--border-color);\n      background: var(--color-white);\n      display: flex;\n      margin-top: 30px;\n      border-radius: 0px;\n      position: relative;\n      .opt-type-display{\n        position: absolute;\n        top: -18px;\n        font-size: 10px;\n        color: white;\n        background-color: var(--color-maersk-blue);\n        padding: 1px 5px;\n        left: 0px;\n        border-radius: 3px 3px 0px 0px;  \n      }\n      .icon-section {\n        padding: 5px;\n        margin: 0px 10px;\n      }\n      .value-section {\n        width: 100%;\n\n        .mainheader {\n          font-weight: 500;\n          line-height: 14px;\n          margin-bottom: 10px;\n          display: flex;\n          align-items: center;\n          .vesel-status {\n            background: var(--color-lightGreen);\n            padding: 2px 6px;\n            border-radius: 3px;\n            color: #007800;\n            font-size: var(--font-size-sm);\n            font-weight: 500;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            max-width: 250px;\n            display: inline-block;\n            margin-left: 5px;\n          }\n        }\n        .data-subtitle {\n          font-size: 14px;\n          .upper-section {\n            margin-bottom: 15px;\n            .header {\n              color: var(--color-font);\n              font-weight: 700;\n            }\n            .time-details{\n              color: var(--color-font);\n              font-size: var(--font-size-xs);\n            }\n            .content {\n              font-size: 14px;\n              .showmore {\n                color: #0073ab;\n                text-decoration: underline;\n                margin-left: 5px;\n                font-size: var(--font-size-sm);\n                cursor: pointer;\n              }\n            }\n            .tags {\n              border-radius: 20px;\n              padding: 1px 5px;\n              line-height: 16px;\n              span {\n                font-size: var(--font-size-sm);\n                white-space: nowrap;\n                font-weight: normal;\n                color: #00243d;\n                border-radius: 3px;\n              }\n            }\n            .icon-section {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              .icon-list {\n                margin-right: 5px;\n              }\n            }\n            .tooltip-text {\n              visibility: hidden;\n              position: absolute;\n              z-index: 1;\n              width: 200px;\n              color: var(--color-black);\n              font-size: 12px;\n              background-color: var(--color-white);\n              border-radius: 10px;\n              padding: 10px 15px 10px 15px;\n              border:solid 1px var(--border-color);\n            }\n\n            .hover-text:hover .tooltip-text {\n              visibility: visible;\n            }\n\n            #top {\n              top: -50px;\n              left: -6rem;\n            }\n            .hover-text {\n              position: relative;\n              display: inline-block;\n              text-align: center;\n            }\n          }\n          .header {\n            color: #545454;\n            font-size: var(--font-size-sm);\n          }\n\n          .progress-section {\n            height: 38px;\n            display: flex;\n            text-align: center;\n            margin-top: 5px;\n            .step-progress {\n              width: 100px;\n              margin-left: 5px;\n              border: solid 1px var(--color-maersk-darkblue);\n              align-items: center;\n              display: flex;\n              justify-content: center;\n              background: var(--color-white);\n              &.error {\n                background-color: var(--color-lightRed);\n                color: #970000;\n                border: solid 1px;\n              }\n              &.success {\n                background-color: var(--color-lightGreen);\n                color: #009700;\n                border: solid 1px;\n              }\n              &.active {\n                display: block;\n                .step {\n                  background-color: var(--color-maersk-darkblue);\n                  color: var(--color-white);\n                }\n              }\n              .step {\n              }\n              .time {\n                font-size: var(--font-size-xs);\n                background-color: var(--color-maersk-blue);\n                color: var(--color-white);\n              }\n            }\n          }\n        }\n        .pull-right {\n          float: right;\n        }\n        .button {\n          margin-top: 8px;\n        }\n      }\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
